import comits from "../../assets/images/comits.webp";
import comit1 from "../../assets/images/comit1.webp";
import checkp from "../../assets/images/checkp.svg";
export default function Commits() {
  return (
    <div className="w-full bg-[#E4F7FF] lg:px-[120px] lg:py-[40px] lg:mt-6">
      <div className="container mx-auto p-3 flex flex-col gap-4 lg:flex-row lg:w-full lg:items-center lg:gap-2">
        <div className="flex flex-col gap-4 w-full lg:w-1/2">
          <div className="flex items-center gap-2">
            <p className="text-sm md:text-base lg:text-lg font-semibold text-[#333333]">
              Cam kết của
            </p>
            <div className="border border-[#27C6FF] w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
              <p className="text-sm md:text-base lg:text-lg font-semibold text-white">
                BlueSkyIT
              </p>
            </div>
          </div>
          <div>
            <p className="text-xl md:text-2xl lg:text-3xl text-[#1375B7] font-semibold">
              Cam kết về sản phẩm & dịch vụ của chúng tôi
            </p>
          </div>
          <div className="w-full h-[152px] lg:h-[110px] px-[24px] py-[16px] flex gap-2 rounded-[6px] bg-white border border-solid border-[#B7E7FF] ">
            <div className="w-11 h-11 bg-[#E4F7FF] rounded-[6px] flex items-center justify-center">
              <img src={checkp} alt="sm" />
            </div>
            <p className="w-[260px] lg:w-full">
              Chúng tôi luôn cam kết cung cấp sản phẩm và dịch vụ với chất lượng
              tốt nhất, không ngừng cải tiến và phục vụ khách hàng bằng cả tâm
              huyết.”
            </p>
          </div>
        </div>
        <div className="w-full lg:w-1/2">
          <img
            src={comits}
            alt="cm"
            className="block md:hidden lg:hidden w-full h-auto object-contain"
          />
          <img
            src={comit1}
            alt="cm1"
            className="hidden md:block lg:block w-full h-au
           object-contain"
          />
        </div>
      </div>
    </div>
  );
}
